<template>
  <div class="page-wrapper">
    <div class="swiper-content">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in swiperList" :key="index">
          <van-image width="100%" height="180px" fit="fill" :src="item.imgUrl" @click="openLink(item)"/>
          <div class="title">{{item.title}}</div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <content-area />
    
    <refund-tips />
    <enter-piece-pop />
    <unionpay-pop />
    <inform-pop />
  </div>
</template>

<script>
import contentArea from './components/content'
import refundTips from './components/refund-tips'
import enterPiecePop from './components/enter-piece-pop'
import unionpayPop from './components/unionpay-pop'
import informPop from './components/inform-pop.vue'
export default {
  name: 'Home',
  components: {
    contentArea,
    refundTips,
    enterPiecePop,
    unionpayPop,
    informPop,
    
  },
  data() {
    return {
      swiperList: [],
    }
  },
  mounted() {
    this.getSwiper();
  },
  methods: {
    getSwiper() {
      let data = {
        filterData: {
          // 查询上线状态的
          rollingStatus: 0
        },
        pageNum: 1,
        // 最多显示5条
        pageSize: 5
      }
      this.$api.h5.queryRollings(data)
        .then(({data: {list}})=>{
          this.swiperList = list || [];;
        });
    },
    close(item) {
      this.$funcDialog.show({
        content: '请问是否关闭当前活动？<br />关闭后将不可恢复！'
      });
      this.$funcDialog.addEventListener(status=>{
        if(status == 'cancel') return;
        this.$api.h5.closeActivity(item.activityId)
        .then(res=>{
          this.init();
        })
      });
    },
   
    
    
    openLink(item) {
      if (!item.imgLinkUrl) {
        return;
      }
      if (item.imgLinkUrl.startsWith('https')) {
        window.location.href = item.imgLinkUrl;
      } else {
        window.location.href = `https://${item.imgLinkUrl}`;
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  min-height calc(100vh - 50px)
  padding 0.1px
  background #F4F4F4;
.swiper-content
  position relative
  .my-swipe
    >>> .van-swipe-item
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;
      height: 180px;
    >>> .van-swipe__indicators
      left 100%
      bottom 14px
      transform translate(-100% - 35px,0)
      position 1001
      .van-swipe__indicator
        border-radius 10px
        transition all linear .3s
        height 5px
        width 5px
      .van-swipe__indicator--active
        width 15px
        height 5px
  .title
    height 34px
    background rgba(0,0,0,0.3)
    position absolute
    width 100%
    z-index 1000
    left 0
    bottom 0
    font-size 14px
    font-weight 500
    color #fff
    line-height 34px
    padding 0 10px 
    box-sizing border-box
    text-align left !important

</style>